import styled from "styled-components";

export const MoreAccessedService = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  padding: 24px;

  background: #fff;
  border-radius: 12px;
  border: 1px solid var(--gray-light);

  cursor: pointer;

  transition:
    all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  > img {
    width: 56px;
    height: 56px;
    object-fit: contain;

    transition: transform 0.3s ease;
  }

  > div {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  &:hover {
    transform: translateY(-4px);

    box-shadow:
      0 8px 24px rgba(0, 0, 0, 0.12);

    border-color: var(--primary-light);

    > img {
      transform: scale(1.1);
    }
  }

  &:active {
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    padding: 20px;
    gap: 16px;

    > img {
      width: 48px;
      height: 48px;
    }
  }

  /* ========================================
     HIGH CONTRAST
  ======================================== */

  body.high-contrast & {
    background: #111 !important;
    border: 2px solid #ffff00 !important;
    box-shadow: none !important;
  }

  body.high-contrast &:hover {
    background: #222 !important;
    border-color: #ffff00 !important;
  }

  body.high-contrast & > div {
    color: #fff !important;
  }
`;

export const MoreAccessedServiceTitle = styled.span`
  color: var(--neutral);

  font-weight: 600;
  font-size: 1.125rem;
  line-height: 26px;

  margin-bottom: 4px;

  transition: color 0.3s ease;

  ${MoreAccessedService}:hover & {
    color: var(--primary);
  }

  /* ========================================
     HIGH CONTRAST
  ======================================== */

  body.high-contrast & {
    color: #ffff00 !important;
  }

  body.high-contrast ${MoreAccessedService}:hover & {
    color: #ffff00 !important;
  }
`;

export const MoreAccessedServiceDescription = styled.span`
  color: var(--neutral-light);

  font-size: 0.875rem;
  line-height: 22px;

  /* ========================================
     HIGH CONTRAST
  ======================================== */

  body.high-contrast & {
    color: #ffffff !important;
  }
`;